<template>
  <v-dialog max-width="550" v-model="dialog.shows.showFilter">
    <v-card>
      <v-card-title>
        <div class="title">{{ $vuetify.lang.t(dialog.title) }}</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-form @submit.prevent="performFilter()">
        <v-card-text>
          <v-container>
            <v-row wrap>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-text-field
                  :label="$vuetify.lang.t('$vuetify.application.cols.apiKey.title')"
                  autocomplete="off"
                  prepend-icon="mdi-key"
                  v-model="filter.apiKey"
                ></v-text-field>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-text-field
                  :label="$vuetify.lang.t('$vuetify.application.cols.shortName.title')"
                  autocomplete="off"
                  prepend-icon="mdi-code-string"
                  v-model="filter.shortName"
                ></v-text-field>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-text-field
                  :label="$vuetify.lang.t('$vuetify.application.cols.name.title')"
                  autocomplete="off"
                  prepend-icon="mdi-account-card-details-outline"
                  v-model="filter.name"
                ></v-text-field>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="6">
                <v-text-field
                  :label="$vuetify.lang.t('$vuetify.application.cols.email.title')"
                  autocomplete="off"
                  prepend-icon="mdi-at"
                  type="email"
                  v-model="filter.email"
                ></v-text-field>
              </v-col>
              <v-col class="mb-0 py-0" cols="12" sm="12"
                     v-if="$auth.check(['ROLE_ADMIN', 'ROLE_COMMERCIAL', 'ROLE_COMPTA'])">
                <v-autocomplete
                  :items="itemsUsers"
                  :label="$vuetify.lang.t('$vuetify.application.cols.user.title')"
                  :loading="isLoading"
                  :search-input.sync="search"
                  autocomplete="off"
                  hide-no-data
                  hide-selected
                  prepend-icon="mdi-account-group-outline"
                  v-model="filter.user"
                  clearable
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog.shows.showFilter = false" text>{{ $vuetify.lang.t('$vuetify.btn.close') }}</v-btn>
          <v-btn @click="resetForm" text>{{ $vuetify.lang.t('$vuetify.btn.reset') }}</v-btn>
          <v-btn
            :loading="loadingBtn"
            color="secondary"
            text
            type="submit"
          >{{ $vuetify.lang.t(dialog.saveBtnTitle) }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  import URLPath from "../../helpers/URL";
  import FilterMixin from '../../mixins/Common/Filters';

  export default {
    mixins: [FilterMixin],
    props: {
      dialog: {
        type: Object,
        default: function () {
          return {
            title: "$vuetify.application.new.title",
            shows: {
              showFilter: false
            },
            saveBtnTitle: "$vuetify.btn.save",
            action: "create"
          };
        }
      },
      filter: {
        type: Object,
        default: function () {
          return {
            name: null,
            shortName: null,
            user: null,
            email: null
          };
        }
      }
    },
    watch: {
      search(val) {
        if (!val)
          return;
        if (val.length < 3)
          return;
        let query = "u_username::iLike::%" + val + "%";
        let params = {
          url: URLPath.USER.LIST,
          params: {
            _search: query
          }
        };
        let self = this;
        this.isLoading = true;
        this.$store
          .dispatch("request", params)
          .then((r) => {
            let self = this;
            r.data.items.forEach(user => {
              self.itemsUsers.push({
                text: user.username,
                value: user.id
              });
            });
            self.itemsUsers = self._.uniqBy(self.itemsUsers, "value");
            self.isLoading = false;
          }).catch(() => {
          self.isLoading = false;
        })
      }
    },
    data: () => ({
      itemsUsers: [],
      search: null,
      isLoading: false
    }),
    methods: {
      resetForm() {
        this.filter.name = null;
        this.filter.shortName = null;
        this.filter.user = null;
        this.filter.email = null;
        this.performFilter();
      },
    }
  };
</script>

<style scoped>

</style>
